import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"text-align":"center","display":"block"} }
const _hoisted_2 = { style: {"display":"inline-block"} }
const _hoisted_3 = { class: "cell-item" }
const _hoisted_4 = { class: "cell-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_User = _resolveComponent("User")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_Lock = _resolveComponent("Lock")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[5] || (_cache[5] = _createElementVNode("div", { style: {"text-align":"center","font-size":"24px","font-weight":"bolder","margin-top":"30px"} }, " 登录系统", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_descriptions, {
        style: {"margin-top":"20px","max-width":"640px","text-align":"center"},
        column: 1,
        size: "large",
        border: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_descriptions_item, { "min-width": 50 }, {
            label: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_el_icon, { style: {"width":"24px"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_User)
                  ]),
                  _: 1
                }),
                _cache[2] || (_cache[2] = _createTextVNode(" 账号 "))
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.formRef.account,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formRef.account) = $event)),
                placeholder: "请输入账号"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, { "min-width": 100 }, {
            label: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_el_icon, { style: {"width":"24px"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Lock)
                  ]),
                  _: 1
                }),
                _cache[3] || (_cache[3] = _createTextVNode(" 密码 "))
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.formRef.password,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formRef.password) = $event)),
                type: "password",
                placeholder: "请输入密码"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, {
            label: " ",
            "min-width": 100
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _ctx.onLoginClick
              }, {
                default: _withCtx(() => _cache[4] || (_cache[4] = [
                  _createTextVNode("登录")
                ])),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
}